import React, { useEffect, useState } from 'react';
import { apiGET } from '../../utilities/apiHelpers';
import { useNavigate } from 'react-router-dom';
import SimpleLoader from '../Loader/SimpleLoader';

const Brand = () => {
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBrands = async () => {
    try {
      setLoading(true);
      const res = await apiGET('v1/brand/all');
      
      // DEBUG: Open your browser console to see this log
      console.log("Brand API Response:", res);

      // Check if the structure matches your JSON: res -> data -> data -> brands
      const brandList = res?.data?.data?.brands || res?.data?.brands || [];
      
      setBrands(brandList);
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBrands();
  }, []);

  if (loading) return <SimpleLoader />;

  return (
    <div className='mt-10 w-full px-6'>
      <style>{`
    .scrollbar-hide::-webkit-scrollbar { display: none; }
    .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
  `}</style>
      <div className='flex justify-between items-center mb-6'>
        <h2 className='text-2xl font-bold text-gray-800'>Top Brands</h2>
        <button 
          onClick={() => {
    navigate('/topbrands');
    window.scrollTo(0, 0); // Force scroll to top
  }}
          className='text-blue-600 hover:underline text-sm font-semibold'
        >
          View All
        </button>
      </div>

      {/* Horizontal Scrollable Container */}
      <div className='flex overflow-x-auto gap-6 pb-4 scrollbar-hide' style={{ WebkitOverflowScrolling: 'touch' }}>
        {brands.length > 0 ? (
          brands.map((brand) => (
            <div 
              key={brand?.id || brand?._id} 
              onClick={() => navigate(`/product/brand/${brand?.id || brand?._id}`)}
              className='flex-shrink-0 cursor-pointer group flex flex-col items-center'
            >
              {/* Brand Logo Card */}
              <div className='w-28 h-28 md:w-32 md:h-32 bg-white border border-gray-200 rounded-2xl shadow-sm flex items-center justify-center p-3 transition-all duration-300 group-hover:shadow-lg group-hover:-translate-y-1'>
                <img
                  src={brand?.brandImgUrl}
                  alt={brand?.name}
                  className='w-full h-full object-contain'
                  onError={(e) => { e.target.src = 'https://via.placeholder.com/150?text=No+Image'; }}
                />
              </div>
              
              {/* Brand Name */}
              <span className='mt-3 text-sm font-medium text-gray-700 group-hover:text-blue-600 transition-colors text-center truncate w-28'>
                {brand?.name}
              </span>
            </div>
          ))
        ) : (
          <div className="w-full py-10 text-center bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
             <p className="text-gray-500">No brands found in the database.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Brand;